<template>
  <div class="user-profile">
    <div class="profile-header">
      <img src="man.png">
      <div class="user-level">
        <div class="level-text">Nivel</div>
        <div class="level">{{ user.comission_level }}</div>
      </div>
    </div>
    <h3 class="user-name">{{ user.name }} {{ user.last_name }}</h3>
    <div class="user-location">
      <img class="location-icon" src="/location.svg">
      <div>
        <div class="location-item">Sucursal: {{ user.store && user.store.name }}</div>
        <div class="location-item">{{ user.store && user.store.address }}</div>
      </div>
    </div>
    <div class="button button-mobile" @click="$router.push('/records')">
      Historial
    </div>
    <!-- <div class="user-stat">
      <div class="stat-value">128m</div>
      <div class="stat-description">ventas del periodo</div>
    </div>
    <div class="user-stat">
      <div class="stat-value">$6528</div>
      <div class="stat-description">comisiones del periodo</div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    user: Object,
  },
};
</script>

<style lang="scss" scoped>
.user-profile {
  width: 100%;
  border-radius: 6px;
  padding: 24px 20px;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.25);
  background-color: white;
}
.user-name {
  font-size: 32px;
  margin-top: 24px;
}
.profile-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.user-location {
  margin: 16px 0;
  display: flex;
}
.user-stat {
  margin-top: 20px;
}
.stat-value {
  font-size: 24px;
}
.stat-description {

}
.location-icon {
  width: auto;
  height: 32px;
  margin-right: 16px;
}
.user-level {
  display: flex;
  background-color: #51bae3;
  border-radius: 100px;
  margin-left: 16px;
}
.level-text {
  padding: 4px 0 4px 16px;
}
.level {
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  padding: 4px 16px 4px 12px;
  margin-left: 12px;
  background-color: darken(#51bae3, 10%);
}
.button {
  background-image: linear-gradient(to right, #f6d365 0%, #f79916 51%, #f6d365 100%);
  display: flex;
  justify-content: center;
  padding: 14px;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.button-mobile {
  display: none !important;
}
@media only screen and (max-width: 920px) {
  .button-mobile {
    display: flex !important;
  }
}
</style>
